var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1663 33.334C31.4675 33.334 33.333 31.4685 33.333 29.1673C33.333 26.8662 31.4675 25.0007 29.1663 25.0007C26.8652 25.0007 24.9997 26.8662 24.9997 29.1673C24.9997 31.4685 26.8652 33.334 29.1663 33.334ZM29.1663 35.0007C32.388 35.0007 34.9997 32.389 34.9997 29.1673C34.9997 25.9457 32.388 23.334 29.1663 23.334C25.9447 23.334 23.333 25.9457 23.333 29.1673C23.333 32.389 25.9447 35.0007 29.1663 35.0007Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1663 26.25C29.6266 26.25 29.9997 26.6231 29.9997 27.0833V28.8215L30.5889 29.4107C30.9143 29.7362 30.9143 30.2638 30.5889 30.5892C30.2635 30.9147 29.7358 30.9147 29.4104 30.5892L28.333 29.5118V27.0833C28.333 26.6231 28.7061 26.25 29.1663 26.25Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6663 19.1667H9.99967V20.8333H11.6663V19.1667ZM9.99967 17.5C9.07917 17.5 8.33301 18.2462 8.33301 19.1667V20.8333C8.33301 21.7538 9.07917 22.5 9.99967 22.5H11.6663C12.5868 22.5 13.333 21.7538 13.333 20.8333V19.1667C13.333 18.2462 12.5868 17.5 11.6663 17.5H9.99967Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 19.1667H16.6667V20.8333H18.3333V19.1667ZM16.6667 17.5C15.7462 17.5 15 18.2462 15 19.1667V20.8333C15 21.7538 15.7462 22.5 16.6667 22.5H18.3333C19.2538 22.5 20 21.7538 20 20.8333V19.1667C20 18.2462 19.2538 17.5 18.3333 17.5H16.6667Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0003 19.1667H23.3337V20.8333H25.0003V19.1667ZM23.3337 17.5C22.4132 17.5 21.667 18.2462 21.667 19.1667V20.8333C21.667 21.7538 22.4132 22.5 23.3337 22.5H25.0003C25.9208 22.5 26.667 21.7538 26.667 20.8333V19.1667C26.667 18.2462 25.9208 17.5 25.0003 17.5H23.3337Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6663 25.8327H9.99967V27.4993H11.6663V25.8327ZM9.99967 24.166C9.07917 24.166 8.33301 24.9122 8.33301 25.8327V27.4993C8.33301 28.4198 9.07917 29.166 9.99967 29.166H11.6663C12.5868 29.166 13.333 28.4198 13.333 27.4993V25.8327C13.333 24.9122 12.5868 24.166 11.6663 24.166H9.99967Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 25.8327H16.6667V27.4993H18.3333V25.8327ZM16.6667 24.166C15.7462 24.166 15 24.9122 15 25.8327V27.4993C15 28.4198 15.7462 29.166 16.6667 29.166H18.3333C19.2538 29.166 20 28.4198 20 27.4993V25.8327C20 24.9122 19.2538 24.166 18.3333 24.166H16.6667Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 10C6.66667 9.53975 7.03977 9.16667 7.5 9.16667H11.6667V7.5H7.5C6.11929 7.5 5 8.61925 5 10V30C5 31.3807 6.11929 32.5 7.5 32.5H24.3789C24.0278 31.9967 23.7541 31.4353 23.5749 30.8333H7.5C7.03977 30.8333 6.66667 30.4602 6.66667 30V10ZM28.3333 23.3924C28.6055 23.3535 28.8837 23.3333 29.1667 23.3333C29.4496 23.3333 29.7278 23.3535 30 23.3924V10C30 8.61933 28.8807 7.5 27.5 7.5H25V9.16667H27.5C27.9602 9.16667 28.3333 9.53975 28.3333 10V23.3924ZM13.3333 9.16667H22.1354V7.5H13.3333V9.16667Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0003 15.0007H6.66699V13.334H30.0003V15.0007Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5.83333C10 5.3731 10.3731 5 10.8333 5C11.2936 5 11.6667 5.3731 11.6667 5.83333V10C11.6667 10.4603 11.2936 10.8333 10.8333 10.8333C10.3731 10.8333 10 10.4603 10 10V5.83333Z",
    fill: "#040E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.667 5.83333C21.667 5.3731 22.0401 5 22.5003 5C22.9606 5 23.3337 5.3731 23.3337 5.83333V10C23.3337 10.4603 22.9606 10.8333 22.5003 10.8333C22.0401 10.8333 21.667 10.4603 21.667 10V5.83333Z",
    fill: "#040E64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6c8f9ef175d5104391a3a3ccc2663ba7.svg";
export { ForwardRef as ReactComponent };